<template>
    <div id="app" class="app">
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: 'app',
        created() {
            this.$store.dispatch('loadSucursal')
        }
    }
</script>

<style lang="scss">
    @import "sass/main";

    body {
        height: 100%;
        overflow-x: hidden;

        #app {
            height: 100%;
        }
    }


</style>
